module.exports = __webpack_public_path__ + "media/images/athletes/4142-6038ceb8b821f95fac0a16a40149f105.png";